import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGradientPm = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 480,
	height: 1024,
	viewBox: "0 0 480 1024",
	fill: "none",
	preserveAspectRatio: "xMidYMid slice",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_4038_454)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				width: 480,
				height: 1024,
				fill: "#FF4E17"
			}),
			/* @__PURE__ */ _jsx("g", {
				filter: "url(#filter0_f_4038_454)",
				children: /* @__PURE__ */ _jsx("ellipse", {
					cx: 375.232,
					cy: 569.065,
					rx: 161.61,
					ry: 344.768,
					fill: "#FF4E17"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				filter: "url(#filter1_f_4038_454)",
				children: /* @__PURE__ */ _jsx("ellipse", {
					cx: 18.5759,
					cy: 1008.15,
					rx: 161.61,
					ry: 344.768,
					fill: "#FFAF22"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				filter: "url(#filter2_f_4038_454)",
				children: /* @__PURE__ */ _jsx("ellipse", {
					cx: 472.57,
					cy: 168.025,
					rx: 161.61,
					ry: 344.768,
					fill: "#ADADAD"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				filter: "url(#filter3_f_4038_454)",
				children: /* @__PURE__ */ _jsx("ellipse", {
					cx: 7.43034,
					cy: 15.8514,
					rx: 161.61,
					ry: 344.768,
					fill: "black"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				filter: "url(#filter4_f_4038_454)",
				children: /* @__PURE__ */ _jsx("ellipse", {
					cx: 7.43034,
					cy: 989.127,
					rx: 161.61,
					ry: 344.768,
					fill: "#FFAF22"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				filter: "url(#filter5_f_4038_454)",
				children: /* @__PURE__ */ _jsx("ellipse", {
					cx: 215.249,
					cy: 316.517,
					rx: 215.249,
					ry: 316.517,
					transform: "matrix(0.504861 0.863201 -0.118038 0.993009 385.722 -403.911)",
					fill: "#ADADAD"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				filter: "url(#filter6_f_4038_454)",
				children: /* @__PURE__ */ _jsx("ellipse", {
					cx: -8.875,
					cy: 30.3407,
					rx: 91.125,
					ry: 194.37,
					fill: "black"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				filter: "url(#filter7_f_4038_454)",
				children: /* @__PURE__ */ _jsx("ellipse", {
					cx: 156,
					cy: 359.822,
					rx: 130.5,
					ry: 278.281,
					fill: "#FF4E17"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				filter: "url(#filter8_f_4038_454)",
				children: /* @__PURE__ */ _jsx("ellipse", {
					cx: 299.5,
					cy: 568.415,
					rx: 130.5,
					ry: 278.281,
					fill: "#FF4E17"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				filter: "url(#filter9_f_4038_454)",
				children: /* @__PURE__ */ _jsx("ellipse", {
					cx: -26.375,
					cy: 913.541,
					rx: 116.625,
					ry: 344.652,
					fill: "#FFAF22"
				})
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_f_4038_454",
			x: -482.972,
			y: -472.297,
			width: 1716.41,
			height: 2082.72,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: 348.297,
					result: "effect1_foregroundBlur_4038_454"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter1_f_4038_454",
			x: -839.628,
			y: -33.2136,
			width: 1716.41,
			height: 2082.72,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: 348.297,
					result: "effect1_foregroundBlur_4038_454"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter2_f_4038_454",
			x: -385.635,
			y: -873.337,
			width: 1716.41,
			height: 2082.72,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: 348.297,
					result: "effect1_foregroundBlur_4038_454"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter3_f_4038_454",
			x: -850.774,
			y: -1025.51,
			width: 1716.41,
			height: 2082.72,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: 348.297,
					result: "effect1_foregroundBlur_4038_454"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter4_f_4038_454",
			x: -850.774,
			y: -52.2353,
			width: 1716.41,
			height: 2082.72,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: 348.297,
					result: "effect1_foregroundBlur_4038_454"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter5_f_4038_454",
			x: 42.0867,
			y: -568.977,
			width: 829.89,
			height: 1330.35,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: 150,
					result: "effect1_foregroundBlur_4038_454"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter6_f_4038_454",
			x: -400,
			y: -464.03,
			width: 782.25,
			height: 988.741,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: 150,
					result: "effect1_foregroundBlur_4038_454"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter7_f_4038_454",
			x: -274.5,
			y: -218.459,
			width: 861,
			height: 1156.56,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: 150,
					result: "effect1_foregroundBlur_4038_454"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter8_f_4038_454",
			x: -131,
			y: -9.86667,
			width: 861,
			height: 1156.56,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: 150,
					result: "effect1_foregroundBlur_4038_454"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter9_f_4038_454",
			x: -443,
			y: 268.889,
			width: 833.25,
			height: 1289.3,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: 150,
					result: "effect1_foregroundBlur_4038_454"
				})
			]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_4038_454",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 480,
				height: 1024,
				fill: "white"
			})
		})
	] })]
});
export default SvgGradientPm;
